// ** UI
import Box from '@mui/material/Box';

// ** Components
import ContentContainer from '@/components/common/ContentContainer';

// ** Types
import type React from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

export type PageContentContainerProps = {
	children?: React.ReactNode;
	maxWidthPx?: number;
	backgroundColor?: string;
	sx?: SxProps<Theme>;
};

const PageContentContainer = ({ children, maxWidthPx, backgroundColor, sx }: PageContentContainerProps) => {
	return (
		<Box
			sx={{
				width: '100%',
				...(backgroundColor ? { bgcolor: backgroundColor } : null)
			}}
		>
			<ContentContainer
				maxWidthPx={maxWidthPx}
				disableGutters
				sx={[(theme) => ({ px: theme.layout.pagePx }), ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
			>
				{children}
			</ContentContainer>
		</Box>
	);
};

export default PageContentContainer;
